(function () {
  window.theme = window.theme || {};

  window.theme.utils = {
    debounce(fn, wait) {
      if (typeof window.debounce === 'function') {
        return window.debounce(fn, wait);
      }

      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), wait);
      };
    },
    fetchConfig(type) {
      if (typeof window.fetchConfig === 'function') {
        return window.fetchConfig(type);
      }

      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: `application/${type || 'json'}`,
        },
      };
    },
  };

  window.theme.pubsub = {
    subscribe(eventName, callback) {
      if (typeof window.subscribe !== 'function') {
        console.error('[mm-constants] pubsub.js must load before mm-cart.js');
        return () => {};
      }
      return window.subscribe(eventName, callback);
    },
    publish(eventName, data) {
      if (typeof window.publish !== 'function') {
        console.error('[mm-constants] pubsub.js must load before mm-cart.js');
        return Promise.resolve();
      }
      return window.publish(eventName, data);
    },
    PUB_SUB_EVENTS: {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      optionValueSelectionChange: 'option-value-selection-change',
      variantChange: 'variant-change',
      cartError: 'cart-error',
    },
  };
})();
